import { DataGrid } from "@mui/x-data-grid";
import { esES } from "@mui/x-data-grid/locales";
import { getTollCellKey } from "../../../utils/tolls";
import styles from "./styles.module.css";

const TOLL_GRID_SX = {
  border: "none",
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "hsl(240 4.8% 95.9%)",
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontWeight: 600,
  },
  "& .MuiDataGrid-row:nth-of-type(odd)": {
    backgroundColor: "white",
  },
  "& .MuiDataGrid-row:nth-of-type(even)": {
    backgroundColor: "hsl(240 4.8% 95.9%)",
  },
  "& .MuiDataGrid-cell": {
    py: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .MuiDataGrid-columnHeader": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const TollGridSection = ({
  section,
  isLoading,
  modifiedCells,
  processRowUpdate,
}) => {
  const sectionClassName =
    section.layout === "full" ? styles.tableSectionFull : styles.tableSection;

  return (
    <div className={sectionClassName}>
      <h4 className={styles.tableTitle}>{section.title}</h4>
      <div className={styles.gridContainer}>
        <DataGrid
          columns={section.columns}
          rows={section.rows}
          hideFooter
          disableColumnFilter
          disableColumnSort
          disableColumnMenu
          disableColumnSelector
          loading={isLoading}
          processRowUpdate={(updatedRow, originalRow) =>
            processRowUpdate(updatedRow, originalRow, section.key)
          }
          getCellClassName={(params) =>
            modifiedCells.has(getTollCellKey(params.row.id, params.field))
              ? styles.modifiedCell
              : ""
          }
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          sx={TOLL_GRID_SX}
        />
      </div>
    </div>
  );
};

export default TollGridSection;
